/*
 * Silk Romance - Exit intent banner ("Before you go... Spin & Win").
 *
 * 2026-10-04: readable rewrite of the previous minified file, behaviour unchanged EXCEPT one early return: when the visitor is
 * eligible for the "your 200 Gift Points are waiting" exit offer (assets/sr-capture-pack.js, window.SRPointsExit), that offer
 * handles the exit instead, so a leaving shopper is never shown two pop-ups at once. Everyone else gets exactly the old banner.
 * Skipped on the cart / checkout pages (window.__SR_CART_OR_CHECKOUT__ is set by layout/theme.liquid).
 *
 * 2026-10-08: a second small IIFE at the bottom loads assets/sr-mytassels-notice.{js,css} (MyTassels.com budget-saree notice)
 * from the same asset folder, so no change to layout/theme.liquid was needed. The loader adds its own cache-buster (MT_V):
 * bump it whenever sr-mytassels-notice.js/css change, because this file's ?v= only changes when THIS file changes.
 */
(function () {
  'use strict';
  if (window.__SR_CART_OR_CHECKOUT__) return;

  var lastY = null;
  var fired = false;

  function showBanner() {
    if (window.SRPointsExit && window.SRPointsExit.eligible()) return; // the points offer owns this exit
    if (fired || (window.SRAttentionManager && !window.SRAttentionManager.request('exit_intent'))) return;
    fired = true;

    var el = document.createElement('div');
    el.className = 'sr-exit-intent';
    el.innerHTML =
      '<button class="sr-exit-intent__close" aria-label="Close">&times;</button>' +
      '<p class="sr-exit-intent__title">Before you go...</p>' +
      '<p class="sr-exit-intent__body">Spin the wheel for a chance at up to 15% off or free shipping.</p>' +
      '<button type="button" class="sr-exit-intent__cta">Spin &amp; Win</button>';
    document.body.appendChild(el);
    if (window.SREvents) window.SREvents.track('exit_intent_shown', {});

    function dismiss(actioned) {
      el.remove();
      if (window.SRAttentionManager) window.SRAttentionManager.release('exit_intent');
      if (actioned && window.SREvents) window.SREvents.track('exit_intent_actioned', {});
    }
    el.querySelector('.sr-exit-intent__close').addEventListener('click', function () { dismiss(false); });
    el.querySelector('.sr-exit-intent__cta').addEventListener('click', function () {
      var launcher = document.querySelector('.sr-spin-launcher');
      if (launcher) launcher.click();
      dismiss(true);
    });
  }

  document.addEventListener('mousemove', function (e) { lastY = e.clientY; });
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY <= 0 && lastY !== null && lastY < 50) showBanner();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') showBanner();
  });
})();

(function () {
  'use strict';
  try {
    var MT_V = '4';
    var me = document.currentScript;
    if (!me || !me.src || window.__SR_CART_OR_CHECKOUT__) return;
    var js = me.src.replace('sr-exit-intent.js', 'sr-mytassels-notice.js') + '&mt=' + MT_V;
    var css = me.src.replace('sr-exit-intent.js', 'sr-mytassels-notice.css') + '&mt=' + MT_V;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = css;
    document.head.appendChild(l);
    var s = document.createElement('script');
    s.src = js;
    s.defer = true;
    document.head.appendChild(s);
  } catch (e) {}
})();
